export function imagesLoaded(scope, callback) {
   // Check if scope is a jQuery object
  if (scope instanceof jQuery) {
    scope = scope.get(0);
  }
  const images = scope.querySelectorAll("img");
  const totalImages = images.length; 
  let loadedCount = 0;

  function imageLoaded() {
    loadedCount++;
    if (loadedCount === totalImages) {
      // console.log("All images are loaded, calling callback");
      callback();
    }
  }

  // Loop through each image and add load event listener
  images.forEach((img) => {
    // Check if the image is already loaded from cache
    if (img.complete && img.naturalHeight !== 0) {
      imageLoaded(); // If already loaded, count it
    } else {
      img.addEventListener('load', imageLoaded); // Otherwise, listen for load event
    }

    // Optionally, handle load errors
    img.addEventListener('error', function() {
      imageLoaded(); // Optionally call this to skip error image
    });
  });

  callback();
}
